import axios from 'axios';
import { SALES } from '../constants';
import { wcApiUrl } from '../WebComponents/commonComponents/customUtils';
import { commonTernary } from './commercialService';

export const ping = async (accessToken, initiateUiResponse, { env, isWCFlow } = {}) => {
  try {
    await axios.get(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_PING_URL,
        initiateUiResponse.REACT_APP_PING_URL
      ),
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (e) {
    return e;
  }
  return 0;
};
